const config = {
    build_number: '616183',
    build_timestamp: '2026-09-18T14:10:09.926Z',
    build_commit: '00f493a9f26b1e7f84ae9a27957f33b026dbd8a0',
};

// locally, the build number is always 4122 (which allows us to load non-English content locally)
if (Number.isNaN(parseInt(config.build_number, 10))) {
    config.build_number = '4122';
}

export default config;
